/* ------------------------------------------------------------------
 * brand-index.js
 * A–Z filtering for sections/d_brand-index.liquid.
 *
 * Every brand is already in the DOM — the letter buttons only toggle
 * [hidden] on the tiles and their group headings, so switching letters
 * costs no request and the page keeps working (showing everything)
 * when JS fails to load.
 * ------------------------------------------------------------------ */

if (!customElements.get('brand-index')) {
    customElements.define(
        'brand-index',
        class BrandIndex extends HTMLElement {
            connectedCallback() {
                this.buttons = Array.from(this.querySelectorAll('button[data-letter]'));
                this.items = Array.from(this.querySelectorAll('[data-brand-item]'));
                this.groups = Array.from(this.querySelectorAll('[data-brand-group]'));
                this.empty = this.querySelector('[data-brand-empty]');

                if (!this.buttons.length) return;

                this.onClick = this.onClick.bind(this);
                this.addEventListener('click', this.onClick);

                this.apply(this.letterFromUrl(), { push: false });
            }

            disconnectedCallback() {
                this.removeEventListener('click', this.onClick);
            }

            /** A letter carried in ?letter=… survives a reload and can be shared. */
            letterFromUrl() {
                const value = new URLSearchParams(window.location.search).get('letter');
                if (!value) return 'all';

                const wanted = value.toUpperCase();
                const known = this.buttons.some((button) => button.dataset.letter === wanted);
                return known ? wanted : 'all';
            }

            onClick(event) {
                const button = event.target.closest('button[data-letter]');
                if (!button || !this.contains(button)) return;

                event.preventDefault();
                this.apply(button.dataset.letter, { push: true });
            }

            apply(letter, { push }) {
                const showAll = letter === 'all';

                this.buttons.forEach((button) => {
                    const active = button.dataset.letter === letter;
                    button.classList.toggle('is-active', active);
                    button.setAttribute('aria-pressed', active ? 'true' : 'false');
                });

                let visible = 0;
                this.items.forEach((item) => {
                    const match = showAll || item.dataset.letter === letter;
                    item.hidden = !match;
                    if (match) visible += 1;
                });

                // With one letter selected its heading is redundant: the
                // active button already says which letter you are looking at.
                this.groups.forEach((group) => {
                    group.hidden = !showAll;
                });

                if (this.empty) this.empty.hidden = visible > 0;

                if (push) this.syncUrl(letter);
            }

            /** replaceState, not a hash — a hash would scroll the page on click. */
            syncUrl(letter) {
                if (!window.history || !window.history.replaceState) return;

                const url = new URL(window.location.href);
                if (letter === 'all') {
                    url.searchParams.delete('letter');
                } else {
                    url.searchParams.set('letter', letter);
                }
                window.history.replaceState({}, '', url);
            }
        }
    );
}
